import date from '../../utils/date'

/**
 * @param {Date|String} value
 * @param {String} mask
 * @returns {String}
 * @description Formats the date with the given mask
 */
export function formatDate(value, mask = 'DD/MM/YY - HH:MM:SS') {
  return date(value).format(mask)
}

/**
 * @param {Date|String} value
 * @returns {String}
 * @description Returns the fromNow date string e.g. "2 mins ago"
 */
export function fromNow(value) {
  return date(value).fromNow()
}

/**
 * @param {Date|String} value
 * @description This function will take any given input date and strip the
 * timezone but give it back as midnight UTC e.g
 * 'Sun Jul 05 2020 00:00:00 GMT+0100 (British Summer Time)'
 * becomes "2020-07-05T00:00:00.000Z"
 */
export function ignoreTimeZoneISOFilter(value) {
  if (typeof value === 'undefined' || value === '') return

  let day
  let month
  let year

  if (value instanceof Date) {
    day = value.getDate()
    month = value.getMonth()
    year = value.getFullYear()
  } else {
    day = date(value).date()
    month = date(value).month()
    year = date(value).year()
  }

  const latestDate = date().utc()
  latestDate.year(year)
  latestDate.month(month)
  latestDate.date(day)
  latestDate.hour(0)
  latestDate.minute(0)
  latestDate.second(0)
  latestDate.millisecond(0)
  return latestDate.startOf('day').toISOString()
}
